import React from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AlertProvider, AlertsContainer, ApplyCanvasTheme, env, PromptContainer, PromptProvider, setEnvVars } from "@inst_proserv/toolkit";

import AppStateProvider from "./context-store/AppStateProvider";
import appReducer from "./context-store/appReducer";
import appInitialState from "./context-store/appInitialState";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { wait_message } from "./utils/post_message";

import "./index.css";
import { ProfileEdit } from "./routes/profile_edit";
import AddMinorLearner from "./routes/AddMinorLearner";
import FormResetPassword from "./components/FormResetPassword/FormResetPassword";

async function fetch_canvas_context(): Promise<any> {
  window.parent.postMessage("aws.canvas_override.get_params", "*");
  try {
    return await wait_message("aws.canvas_override.params")
  } catch {
    return null;
  }
}

(async () => {
  const ctx = await fetch_canvas_context();
  setEnvVars(ctx);

  let application;

  if (ctx?.params?.aws_profile_view) {
    appInitialState.isAppLoading = false;
    application = <ProfileEdit />
  } else {
    application = <BrowserRouter>
      <Routes>
        <Route path='/lti3/addMinorLearner' element={<AddMinorLearner />} />
        <Route path="/passwordreset" element={<FormResetPassword />} />
        <Route path='*' element={<App />} />
      </Routes>
    </BrowserRouter>
  }

  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<>
    <ApplyCanvasTheme brand={env.canvasBrandConfig} >
      <AppStateProvider initialState={appInitialState} reducer={appReducer}>
        <PromptProvider>
          <AlertProvider>
            <PromptContainer />
            <AlertsContainer />
            {application}
          </AlertProvider>
        </PromptProvider>
      </AppStateProvider>
    </ApplyCanvasTheme>
  </>);
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
